import {
  Component,
  OnInit,
  Input,
  ChangeDetectionStrategy,
  forwardRef,
  Output,
  EventEmitter,
  AfterViewInit,
  ChangeDetectorRef
} from '@angular/core';

import {
  FormArray,
  FormGroup,
  ControlContainer,
  FormGroupDirective,
  NG_VALUE_ACCESSOR,
  FormBuilder,
  FormControl
} from '@angular/forms';
import { CustomService } from '../shared/grid-form.service';
import { GridDefinition, GridOptions } from '../shared/grid.interface';
import { CoreInputValidationService } from '@tmhcc-ng-lib/framwork/core-inputs';
import { has } from '@tmhcc/util';
import { InputConfig } from '@tmhcc-ng-lib/framwork/form-inputs';

@Component({
  selector: 'ac-custom-grid',
  templateUrl: './custom-grid-table.component.html',
  styleUrls: ['./custom-grid-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CustomGridTableComponent),
      multi: true
    }
  ]
})
export class CustomGridTableComponent implements OnInit, AfterViewInit {
  @Input() gridForm: FormGroup;
  @Input() GridDefinition: GridDefinition;
  @Input() GridSetting: GridOptions;
  @Input() tableLabel?: string;
  @Input() GridPropName = 'tablesRow';
  @Output() isGridRowDelete = new EventEmitter();
  @Output() gridResponseData = new EventEmitter<{
    type?: any;
    selectedRowData?: any;
    value: any;
    IsInvalid: boolean;
  }>();

  dtOptions: DataTables.Settings = {};
  customForm: FormGroup;
  validForm: boolean;
  dummyList: any;
  selectedValuesList: any = [];

  constructor(
    private validationService: CoreInputValidationService,
    private customService: CustomService,
    public controlContainer: ControlContainer,
    public parentForm: FormGroupDirective,
    private fb: FormBuilder,
    private detection: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.dtOptions = this.customService.inputTableOptions(
      this.GridSetting.paging
    );
    if ((<FormArray>this.parentForm.form.get(this.GridPropName)).length) {
      this.parentForm.form.removeControl(this.GridPropName);
    }
    this.parentForm.form.addControl(this.GridPropName, this.fb.array([]));
  }

  ngAfterViewInit() {
    if (this.GridDefinition.Rows.length > 0) {
      this.setServiceData();
      this.detection.markForCheck();
    }
  }

  onValChanges(element): void {
    this.parentForm.form.controls[this.GridPropName]['controls'][
      element
    ].valueChanges.subscribe(val => {
      const dataArray = [];
      this.parentForm.form.controls.tableRows['controls'].forEach(item => {
        const formValues = item.getRawValue();
        dataArray.push(formValues);
      });
      for (const a of this.parentForm.form.controls.tableRows['controls']) {
        if (a.valid) {
          this.validForm = true;
        } else {
          this.validForm = false;
          this.validationService.setFormSubmission(true);
          break;
        }
      }
      this.gridResponseData.emit({
        value: dataArray,
        IsInvalid: this.validForm
      });
    });

    this.GridDefinition.Columns.forEach(field => {
      this.parentForm.form.controls[this.GridPropName]['controls'][
        element
      ].controls[field.fieldInfo.fieldName].statusChanges.subscribe(val => {
        let selectedRowData = this.parentForm.form.controls[this.GridPropName][
          'controls'
        ][element];
        let Updateval = this.parentForm.form.controls[this.GridPropName][
          'controls'
        ][element].controls[field.fieldInfo.fieldName].value;
        if (has(field, 'dependency')) {
          this.chkformDependency(field, selectedRowData, Updateval);
        }
      });
    });
  }

  chkformDependency(field: InputConfig, form, updatedControlValue) {
    if (field.dependency.childControl) {
      const dependenyControls = field.dependency.childControl.split(',');
      dependenyControls.forEach(element => {
        if (updatedControlValue) {
          form.get(element).enable();
        } else {
          form.get(element).disable();
        }
      });
    }
  }

  setServiceData() {
    const gridData = this.GridDefinition.Rows;
    const gridColumnData = this.GridDefinition.Columns;
    gridData.forEach((element, index) => {
      this.tableRows.push(
        this.customService.populateExistItem(element, gridColumnData)
      );
      const rows = <FormArray>this.parentForm.form.get(this.GridPropName);
      this.onValChanges(rows.length - 1);
    });
    this.responseAddedData();
  }

  responseAddedData() {
    const dataArray = [];
    this.parentForm.form.controls.tableRows['controls'].forEach(item => {
      const formValues = item.getRawValue();
      dataArray.push(formValues);
    });
    for (const a of this.parentForm.form.controls.tableRows['controls']) {
      if (a.valid) {
        this.validForm = true;
      } else {
        this.validForm = false;
        this.validationService.setFormSubmission(true);
        break;
      }
    }

    this.gridResponseData.emit({
      value: dataArray,
      IsInvalid: this.validForm //this.parentForm.form.invalid
    });
  }

  addRowInForm() {
    const rows = <FormArray>this.parentForm.form.get(this.GridPropName);
    this.tableRows.push(
      this.customService.createRowItem(this.GridDefinition.Columns)
    );
    this.onValChanges(rows.length - 1);
    this.validationService.setFormSubmission(false);
  }

  deleteElementFromForm(index: number) {
    (<FormArray>this.parentForm.form.get(this.GridPropName)).removeAt(index);
    const dataArray = [];
    this.parentForm.form.controls.tableRows['controls'].forEach(item =>
      dataArray.push(item.value)
    );
    this.responseAddedData();
  }

  async deleteIndividualRow(index: number) {
    this.deleteElementFromForm(index);
    document.getElementById('table-row-' + index).style.visibility = 'collapse';
  }

  get tableRows() {
    return (<FormArray>this.parentForm.form.get(this.GridPropName)).controls;
  }

  saveData() {
    const dataArray = [];
    this.parentForm.form.controls.tableRows['controls'].forEach(item =>
      dataArray.push(item.value)
    );
    this.parentForm.form.value.tableRows = dataArray;

    if (
      this.parentForm.form.controls.tableRows['controls'] == undefined ||
      this.parentForm.form.controls.tableRows['controls'].length == 0
    ) {
      this.validForm = true;
    } else {
      for (const a of this.parentForm.form.controls.tableRows['controls']) {
        if (a.valid) {
          this.validForm = true;
        } else {
          this.validForm = false;
          this.validationService.setFormSubmission(true);
          break;
        }
      }
    }
    this.parentForm.form.controls[this.GridPropName]['controls'].forEach(
      (item, index) => {
        Object.keys(
          this.parentForm.form.controls[this.GridPropName]['controls'][index][
            'controls'
          ]
        ).forEach(field => {
          const control = this.parentForm.form.controls[this.GridPropName][
            'controls'
          ][index].get(field);
          if (control !== null) {
            control.markAsTouched();
          }
        });
      }
    );
  }
}
